/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ sent: NonNullable<unknown>, total: NonNullable<unknown> }} Read_Along_Ai_UsageInputs */

const en_read_along_ai_usage = /** @type {(inputs: Read_Along_Ai_UsageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sent} of ${i?.total} document words sent`)
};

const es_read_along_ai_usage = /** @type {(inputs: Read_Along_Ai_UsageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sent} de ${i?.total} palabras del documento enviadas`)
};

/**
* | output |
* | --- |
* | "{sent} of {total} document words sent" |
*
* @param {Read_Along_Ai_UsageInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_ai_usage = /** @type {((inputs: Read_Along_Ai_UsageInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Ai_UsageInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_ai_usage(inputs)
	return en_read_along_ai_usage(inputs)
});